// helper: retry calling launchEmbed() until video player appears
export const pollPrimaVideoLaunch = (uniqueId: string, retries = 20, delay = 200) => {
    let attempts = 0;
    const interval = setInterval(() => {
        const fn = (window as any).launchEmbed;
        const container = document.getElementById(uniqueId) || document;
        const player = container.querySelector('div[id^="vjs_video_"]');

        if (player) {
            // console.log('[article-scripts] Video player detected, stopping checks');
            clearInterval(interval);
            return;
        }

        if (typeof fn === "function") {
            // console.log(`[article-scripts] Attempt ${attempts + 1}: calling launchEmbed()`);
            try {
                fn();
            } catch (err) {
                // console.error('[article-scripts] launchEmbed() error:', err);
            }
        }

        if (++attempts >= retries) {
            // console.warn('[article-scripts] Player not found after retries');
            clearInterval(interval);
        }
    }, delay);
};

export const revertReplacedTagsOfArticleScripts = (scripts: string) => {
    return scripts.replace(/(<\/?)(replaced_script_tag_of_a_safe_mk_script>)/gi, "$1script>");
};
